import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';

import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { tap, take, map } from 'rxjs/operators';

import { LocalDate } from '@fcom/core/utils';

import { selectSearch } from '../store/selectors';
import { SearchState } from '../interfaces';
import { setSearch } from '../store/actions/search.actions';
import { getCurrentDateIfSearchIsBeforeToday } from '../utils/timetable.utils';

@Injectable({
  providedIn: 'root',
})
export class TimetableSearchGuard implements CanActivate {
  constructor(private store$: Store) {}

  /**
   * This guard protects from the store from rehydrating from session storage with dates before the current date.
   *
   * Without this requests will be made to the backed for current dates, causing 400 bad request errors.
   */
  canActivate(): Observable<boolean> {
    return this.store$.pipe(
      selectSearch(),
      tap((search: SearchState) => this.checkSelectedMonth(search)),
      map(() => true),
      take(1)
    );
  }

  private checkSelectedMonth(search: SearchState): void {
    const today = new Date();
    const currentYear = today.getFullYear();
    const currentMonth = today.getMonth() + 1;
    const currentDate = getCurrentDateIfSearchIsBeforeToday(search);

    if (currentDate) {
      this.store$.dispatch(
        setSearch({
          selectedMonth: {
            year: currentYear,
            month: currentMonth,
          },
          selectedDay: LocalDate.now(),
        })
      );
    }
  }
}
